 <div class="body-b thaksBxmain" slot="modalContent">
      <div class="thaksBxInner">
       <div class="headerLogo"> <img src="assets/icons/brand-logo.svg" alt="brand-logo"></div>
       <img class="checkImg" src="assets/icons/check-green.jpg" alt="brand-logo">
       <h1 class="header-h2">Thank you for your feedback!</h1>     
      </div>
</div>